import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Params } from '@angular/router';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductService, ProductSpec, ProductSpecIspData } from 'src/app/services/api/product/product.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { CatalogDetailSaveComponent } from './catalog-detail-save/catalog-detail-save.component';

@Component({
  selector: 'app-catalog-detail',
  templateUrl: './catalog-detail.component.html',
  styleUrls: ['./catalog-detail.component.scss']
})
export class CatalogDetailComponent implements OnInit {

  name: string;
  productSpec: ProductSpec;

  searchGroup: FormGroup;

  data: ProductSpecIspData[];

  isActive: boolean;

  displayedColumns: string[] = ['catalogName', 'selected', 'orquestable'];

  dialogCatalogDetailsSaveRef: MatDialogRef<CatalogDetailSaveComponent>;

  constructor(private productService: ProductService, private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder, private breadcrumbsService: BreadcrumbsService,
    private notificationsService: NotificationsService, public dialog: MatDialog) {

  }

  ngOnInit() {
    this.searchGroup = this.formBuilder.group({
      productName: this.formBuilder.control({ value: '', disabled: true }),
      productVersion: this.formBuilder.control(''),
    });
    this.data = [];
    this.productSpec = {
      productName: null,
      productNamingId: null,
      versions: [],
      enabled: false,
      catalogResponseList: []
    };
    this.isActive = false;

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.breadcrumbsService.sendBreadcrumbs(
        {
          breadcrumbs: [
            { title: 'Administración', url: 'provision/management' },
            { title: 'Catálogo', url: 'provision/management/catalog' },
            { title: 'Detalle de producto', url: 'provision/management/catalog/detail', params: { name: params.name } },
          ]
        });
      this.name = params.name;
      this.loadProductDetails();
    });

  }

  get productNameControl(): FormControl {
    return this.searchGroup.get('productName') as FormControl;
  }

  get productVersionControl(): FormControl {
    return this.searchGroup.get('productVersion') as FormControl;
  }

  loadProductDetails() {
    this.productService.getProductSpecDetails(this.name).subscribe(
      (data) => {
        this.productSpec = data;
        this.searchGroup.get('productName').setValue(this.productSpec.productName);
        this.searchGroup.get('productVersion').setValue(this.productSpec.versions.find(version => version.enabled === true).name);
        this.isActive = true;
        this.data = this.productSpec.catalogResponseList;
      },
      (error) => {
        this.notificationsService.showNotification('No se ha podido cargar el detalle del producto', NotificationLevel.ERROR);
      });
  }

  changeSelectedVersion() {
    this.isActive = this.productSpec.versions.find(version => version.name === this.searchGroup.get('productVersion').value).enabled;
  }

  changeEnabled() {
    this.productSpec.versions.forEach(
      (version) => {
        if (version.name !== this.productVersionControl.value) {
          version.enabled = false;
        } else {
          version.enabled = true;
        }
      }
    );
  }

  reset() {
    this.loadProductDetails();
  }

  save() {
    this.dialogCatalogDetailsSaveRef = this.dialog.open(CatalogDetailSaveComponent, {
      width: '850px'
    });

    this.dialogCatalogDetailsSaveRef.afterClosed().subscribe((accept) => {
      if (accept) {
        this.productService.modifyProductSpec(this.productSpec).subscribe(
          (data) => {
            this.notificationsService.showNotification('El producto se ha guardado correctamente', NotificationLevel.SUCCESS);
          },
          (error) => {
            this.notificationsService.showNotification('Ha habido un problema al guardar el producto', NotificationLevel.ERROR);
          }
        );
      }
    });
  }

  setExternalAPI(ispName: string, orchestable: boolean) {
    this.productSpec.catalogResponseList.find(ispConfig => ispConfig.catalogName === ispName).externalAPI =
      !orchestable;
  }

  setOrchestable(ispName: string, externalAPI: boolean) {
    this.productSpec.catalogResponseList.find(ispConfig => ispConfig.catalogName === ispName).orquestable =
      !externalAPI;
  }

  setSelected(ispName: string) {
    this.productSpec.catalogResponseList.find(ispConfig => ispConfig.catalogName === ispName).orquestable =
      false;
  }

}
